import { taskService } from '../../services'

// initial state
const state = () => ({
  tasks: [],
  task: null,
  status: {},
})

// actions
const actions = {
  getTasks({ commit }, confirmed = true) {
    commit('waitResponse');
    taskService.getTasks(confirmed)
      .then(
        tasks => {
          commit('tasksSuccess', tasks);
        },
        error => {
          commit('tasksFailure', error);
        }
      );
  },
  getTasksConfirmed({ commit }, invoiced = true) {
    commit('waitResponse');
    taskService.getTasksConfirmed(invoiced)
      .then(
        tasks => {
          commit('tasksSuccess', tasks);
        },
        error => {
          commit('tasksFailure', error);
        }
      );
  },
  getTasksByDateRange({ commit }, dates) {
    commit('waitResponse');
    taskService.getTasksByDateRange(dates.startDate, dates.endDate)
      .then(
        tasks => {
          commit('tasksSuccess', tasks);
        },
        error => {
          commit('tasksFailure', error);
        }
      );
  },
  getTask({ commit }, taskId) {
    taskService.getTask(taskId)
      .then(
        task => {
          commit('taskSuccess', task);
        },
        error => {
          commit('taskFailure', error);
        }
      );
  },
  createTask({ commit }, taskData) {
    taskService.createTask(taskData)
      .then(
        task => {
          commit('taskSuccess', task);
        },
        error => {
          commit('taskFailure', error);
        }
      );
  },
  editTask({ commit }, {taskId, taskData}) {
    taskService.editTask(taskId, taskData)
      .then(
        task => {
          commit('taskSuccess', task);
        },
        error => {
          commit('taskFailure', error);
        }
      );
  },
  deleteTask({ commit }, taskId) {
    taskService.deleteTask(taskId)
      .then(
        task => {
            commit('taskDelete', task.id);
          },
          error => {
            commit('taskFailure', error);
          }
      );
  },
}

// mutations
const mutations = {
  waitResponse(state) {
      state.status = { isWaiting: true };
  },
  tasksSuccess(state, tasks) {
      state.tasks = tasks;
      state.status = {};
  },
  tasksFailure(state, error) {
      console.log(state, error);
      state.status = {};
  },
  taskSuccess(state, task) {
      state.task = task;
      state.status = {};
  },
  taskFailure(state, error) {
      console.log(state, error);
      state.status = {};
  },
  taskDelete(state, taskId) {
      let index = state.tasks.findIndex(task => task.id == taskId);
      state.tasks.splice(index, 1);
      state.status = {};
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
